@if (flowId) {
  <app-link-icon
    class="clickable"
    height="16px"
    width="16px"
    color="var(--gray-600)"
    ngbTooltip="Copier le lien admin"
    i18n-ngbTooltip
    (click)="copyAdminLink()"
  />
  @if (partnerLinkAvailable) {
    <app-external-link-icon
      class="clickable"
      height="16px"
      width="16px"
      color="var(--gray-600)"
      ngbTooltip="Copier le lien partenaire"
      i18n-ngbTooltip
      (click)="copyPartnerLink()"
    />
  }
}
